// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".stats--card[data-v-e4a6ab4c]{border-radius:50px;width:-moz-max-content;width:max-content}.stats--count[data-v-e4a6ab4c]{margin-left:7px;position:relative}.stats--text[data-v-e4a6ab4c]{font-size:12px}.stats--count--dot[data-v-e4a6ab4c]{border-radius:50%;height:10px;width:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
